// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__0s4SK","links":"styles_links__dXbE+","getAccessLink":"styles_getAccessLink__qVSkH","tariffsLink":"styles_tariffsLink__5AT+x"};